module.exports = __webpack_public_path__ + "img/puppy-what-we-do-1.ab3543b8.webp";